export enum SearchResultsTabs {
  All = 'ALL',
  UNMatched = 'UNMATCHED',
  PartialMatched = 'PARTIAL MATCHED',
  Matched = 'MATCHED',
  SalvageRequest = 'SALVAGED',
}
